export var TextInputAppearance;

(function (TextInputAppearance) {
  TextInputAppearance[TextInputAppearance["Default"] = 0] = "Default";
  TextInputAppearance[TextInputAppearance["Disabled"] = 1] = "Disabled";
  TextInputAppearance[TextInputAppearance["Error"] = 2] = "Error";
  TextInputAppearance[TextInputAppearance["Success"] = 3] = "Success";
  TextInputAppearance[TextInputAppearance["ReadOnly"] = 4] = "ReadOnly";
  TextInputAppearance[TextInputAppearance["Search"] = 5] = "Search";
})(TextInputAppearance || (TextInputAppearance = {})); // to start from 5 is necessary for the differentiation of enum values between TextInputAppearance and TextAreaAppearance for later used switch cases


export var TextAreaAppearance;

(function (TextAreaAppearance) {
  TextAreaAppearance[TextAreaAppearance["Default"] = 5] = "Default";
  TextAreaAppearance[TextAreaAppearance["Disabled"] = 6] = "Disabled";
  TextAreaAppearance[TextAreaAppearance["Error"] = 7] = "Error";
  TextAreaAppearance[TextAreaAppearance["ReadOnly"] = 8] = "ReadOnly";
  TextAreaAppearance[TextAreaAppearance["Search"] = 9] = "Search";
})(TextAreaAppearance || (TextAreaAppearance = {}));